import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedHTMLMessage } from 'react-intl';

import { acceptEula } from 'actions';
import { getCookie } from 'common/cookies';

import EnvConfig from 'env.config';

import ModalWrapper from 'components/Modals/ModalWrapper';
import MustHaveReadText from 'components/MustHaveReadText';

const contains = (intl, messageId) => intl && !!intl.messages[messageId] && intl.messages[messageId] !== 'End-User License Agreement';

const { eulaCookieName } = EnvConfig;

const Eula = ({ dispatch, intl, dictionaryLoaded, onConfirm, onCancel }) => {
  const [allRead, setAllRead] = useState(false);

  const eulaAccepted = !!getCookie(eulaCookieName);
  const isEulaEnabled = contains(intl, 'eula');
  const content = <FormattedHTMLMessage id="eula" />;

  useEffect(() => {
    if (dictionaryLoaded && !isEulaEnabled) {
      dispatch(acceptEula());
    }
  }, []);

  const onCancelClick = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const onConfirmClick = () => {
    dispatch(acceptEula(true));

    if (onConfirm) {
      onConfirm();
    }
  };

  if (!eulaAccepted && isEulaEnabled && content) {
    return (
      <ModalWrapper
        title={ <h1><FormattedHTMLMessage id="eula.title" /></h1> }
        className="modal-eula"
        disableConfirm={ !allRead }
        showCancel={ false }
        showClose={ false }
        btnConfirmTitle="I Agree"
        content={ <MustHaveReadText
          content={ content }
          IsTextRead={ value => setAllRead(value) }
        /> }
        footer={ !allRead ? 'You must read all of the text above before you can proceed.' : 'By clicking `I Agree` you confirm that you have read and agree to all of the terms set out in the end-user license agreement.' }
        onConfirm={ onConfirmClick }
        onCancel={ onCancelClick }
      />
    );
  }
  return <React.Fragment />;
};

Eula.propTypes = {
  dispatch: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  dictionaryLoaded: PropTypes.bool
};

Eula.defaultProps = {
  onConfirm: null,
  onCancel: null,
  dictionaryLoaded: false
};

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    app: {
      dictionaryLoaded
    }
  } = state;

  return {
    dictionaryLoaded
  };
}

export default injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps
)(Eula));
